export type ThemeMode = 'light' | 'dark';

// Same palette as SlightorCRM (slightercrm/src/index.css) so both consoles read
// as one product. Dark steps are chosen against #131316, not flipped from light.
export const tokens: Record<ThemeMode, Record<string, string>> = {
  light: {
    bg:              '#FAFAF7',
    surface:         '#FFFFFF',
    surfaceAlt:      '#F4F3EE',
    surfaceElevated: '#FFFFFF',
    border:          '#ECEAE3',
    borderStrong:    '#D8D4C8',
    textPrimary:     '#15171A',
    textSecondary:   '#4A4D52',
    textMuted:       '#8A8C92',
    primary:         '#C8A55B',
    primaryDark:     '#9C7E3F',
    primaryHover:    '#B8924E',
    primarySoft:     'rgba(200, 165, 91, 0.10)',
    onPrimary:       '#FFFFFF',
    success: '#4F7B36', successSoft: 'rgba(79, 123, 54, 0.10)',
    warning: '#A86F1E', warningSoft: 'rgba(168, 111, 30, 0.10)',
    danger:  '#A53B30', dangerSoft:  'rgba(165, 59, 48, 0.10)',
    info:    '#2F66A0', infoSoft:    'rgba(47, 102, 160, 0.10)',
  },
  dark: {
    bg:              '#0A0A0C',
    surface:         '#131316',
    surfaceAlt:      '#1A1A1E',
    surfaceElevated: '#1F1F24',
    border:          '#26262C',
    borderStrong:    '#3A3A42',
    textPrimary:     '#F4F1EB',
    textSecondary:   '#B5AE9F',
    textMuted:       '#8A8170',
    primary:         '#D4B373',
    primaryDark:     '#B8924E',
    primaryHover:    '#E5C77D',
    primarySoft:     'rgba(212, 179, 115, 0.14)',
    onPrimary:       '#FFFFFF',
    success: '#88B362', successSoft: 'rgba(136, 179, 98, 0.14)',
    warning: '#D4A65B', warningSoft: 'rgba(212, 166, 91, 0.14)',
    danger:  '#D86B5E', dangerSoft:  'rgba(216, 107, 94, 0.14)',
    info:    '#6BA0D8', infoSoft:    'rgba(107, 160, 216, 0.14)',
  },
};

const cssVar = (key: string) => `--color-${key.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)}`;

export function applyTheme(mode: ThemeMode): void {
  const set = tokens[mode];
  const root = document.documentElement;
  for (const [key, value] of Object.entries(set)) {
    root.style.setProperty(cssVar(key), value);
  }
  root.classList.toggle('dark', mode === 'dark');
}
